import styled from "@emotion/styled";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { Button } from "components/UI";
import { useChurchStore } from "features/churches";
import {
  useDeleteRevenueMethod,
  useRevenueStore,
  useUpdateRevenueMethod
} from "features/finances";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { BaseModal } from "./BaseModal";

const SmallText = styled.span`
  color: #8e8e8e;
  font-size: 10px;
  font-weight: 500;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.label`
  color: #5b5b5b;
  font-size: 12px;
  font-weight: 500;
`;

const Input = styled.input`
  border-radius: 4px;
  border: 0.73px solid #b3b3b3;
  height: 40px;
  outline: none;
  padding: 8px;
`;

const Textarea = styled.textarea`
  resize: none;
  border-radius: 4px;
  border: 0.73px solid #b3b3b3;
  outline: none;
  padding: 8px;
  font-family: inherit;
`;

const revenueMethodSchema = yup.object({
  name: yup.string().required("Revenue method name is required"),
  description: yup.string().required("Revenue method description is required")
});

export function UpdateRevenueMethodModal({ data }) {
  const updateRevenueMethodOpen = useRevenueStore(
    state => state.updateRevenueMethodOpen
  );
  const closeUpdateRevenueMethodModal = useRevenueStore(
    state => state.closeUpdateRevenueMethodModal
  );
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const updateRevenueMethodMutation = useUpdateRevenueMethod();
  const deleteRevenueMethodMutation = useDeleteRevenueMethod();

  const { register, handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      name: data?.name,
      description: data?.description
    },
    resolver: yupResolver(revenueMethodSchema)
  });

  useEffect(() => {
    if (data) {
      setValue("name", data?.name);
      setValue("description", data?.description);
    }
  }, [data]);

  const onSubmit = values => {
    updateRevenueMethodMutation.mutate(
      {
        churchId: selectedChurch?.id,
        revenueMethodId: data?.id,
        revenueMethodData: values
      },
      {
        onSuccess: () => {
          reset();
        }
      }
    );
  };

  return (
    <BaseModal
      title="Edit revenue method"
      isOpen={updateRevenueMethodOpen}
      onClose={closeUpdateRevenueMethodModal}
      footer={
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Button
            flavor="neutral"
            size="small"
            onClick={() => {
              deleteRevenueMethodMutation.mutate({
                churchId: selectedChurch?.id,
                revenueMethodId: data?.id
              });
            }}
          >
            Delete
          </Button>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Button flavor="white" size="small">
              Cancel
            </Button>
            <Button size="small" onClick={handleSubmit(onSubmit)}>
              Save Changes
            </Button>
          </Stack>
        </Stack>
      }
    >
      <Field>
        <Label htmlFor="name">Revenue Method</Label>
        <Input id="name" {...register("name")} />
      </Field>
      <Field>
        <Label htmlFor="description">Description</Label>
        <Textarea id="description" rows={10} {...register("description")} />
      </Field>
      <SmallText>No more than 50 characters</SmallText>
    </BaseModal>
  );
}
